const services = [
  {
    icon: 'ri-tools-fill',
    title: 'Installation & Upgrades',
    items: [
      'Electrical Installations',
      'Full & Partial Rewiring',
      'Consumer Unit Upgrades',
      'Lighting Installation',
      'LED Lighting Upgrades',
      'Outdoor & Garden Lighting',
      'Security Lighting',
      'Socket & Switch Installation',
      'EV Charger Installation',
      'Smart Home Installations',
      'Home Automation Systems',
      'Heating Controls & Thermostats',
      'Electric Shower Installation',
      'Kitchen Electrical Installations',
    ],
  },
  {
    icon: 'ri-settings-3-fill',
    title: 'Repair & Maintenance',
    items: [
      'Electrical Repairs',
      'Fault Finding & Diagnostics',
      'Tripping Circuits',
      'Fuse Box Repairs',
      'Lighting Repairs',
      'Socket & Switch Repairs',
      'Emergency Call-Outs',
      'Electrical Maintenance Contracts',
      'PAT Testing',
      'Electrical Appliance Repairs',
    ],
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'Safety & Compliance',
    items: [
      'EICR Testing',
      'Landlord Safety Certificates',
      'Homebuyer Electrical Reports',
      'Smoke & Heat Alarm Installation',
      'Fire Alarm Systems',
      'Surge Protection',
      'Earthing & Bonding',
      'RCD Testing',
    ],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4 font-display">
            Our Electrical Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Professional electrical solutions for homes and businesses across Bridgend and South Wales
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-primary/10 rounded-xl mr-4">
                  <i className={`${service.icon} text-primary text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-secondary font-display">{service.title}</h3>
              </div>
              <ul className="space-y-3">
                {service.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start text-gray-700 group">
                    <i className="ri-flashlight-fill text-primary text-lg mr-3 flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm font-medium group-hover:text-primary transition-colors">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-xl mx-auto mb-4">
              <i className="ri-timer-flash-fill text-primary text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-secondary mb-2 font-display">Fast Response</h4>
            <p className="text-gray-600 text-sm">
              Rapid response times across Bridgend. Emergency callouts available 24/7 for urgent electrical issues.
            </p>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-xl mx-auto mb-4">
              <i className="ri-shield-star-fill text-primary text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-secondary mb-2 font-display">Fully Certified</h4>
            <p className="text-gray-600 text-sm">
              NAPIT approved, 18th Edition certified, and fully insured for all domestic and commercial electrical work.
            </p>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-xl mx-auto mb-4">
              <i className="ri-money-pound-circle-fill text-primary text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-secondary mb-2 font-display">Free Quotes</h4>
            <p className="text-gray-600 text-sm">
              Transparent, competitive pricing with free no-obligation quotes for every electrical project.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
